/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Activity from 'shared/ui/components/charts/Activity.vue';
import AreaChart from 'shared/ui/components/charts/AreaChart.vue';
import BarChart from 'shared/ui/components/charts/BarChart.vue';
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';
import LineChart from 'shared/ui/components/charts/LineChart.vue';
import Registrations from 'shared/ui/components/charts/Registrations.vue';
import StackedBarsChart from 'shared/ui/components/charts/StackedBarsChart.vue';

// Constants
const TYPE_COMPONENT_MAPPING = {
    'area': AreaChart,
    'bar': BarChart,
    'line': LineChart,
    'stacked': StackedBarsChart,
    'activity': Activity,
    'registrations': Registrations
};

/**
 * This component is used to show charts in a tabbed manner
 *
 * @vue-prop {ChartConfig[]} charts the collection of charts to display
 *
 * @example
 * tabbed-charts(:charts="charts")
 *
 * @category shared.ui.components.charts
 * @exports TabbedCharts
 * @component
 */
const __vue_script__ = {
    name: 'TabbedCharts',

    components: { BarChart, ExpandableContent, LineChart },

    props: {
        event: {
            type: Object,
            required: true
        },

        charts: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            currentTab: this.charts[0] || '',
            chartConfigs: this.charts.map(this.$utils.charts.getChartConfigByName),
            regAccessType: undefined,
        };
    },

    computed: {
        /** @returns {ChartConfig} */
        currentChart() {
            return this.chartConfigs.find(c => c.name === this.currentTab);
        },

        /** @returns {ChartConfig} */
        currentChartProps() {
            const currentStage = this.$utils.workspaces.workspaceState(this.event);
            if ((this.currentChart.stages || []).includes(currentStage)) {
                const { begin, cease } = this.maxTwoYearsTimeRange({
                    start: this.event.description.start_time,
                    end: currentStage === 'present' ? Math.round(Date.now() / 1000) : this.event.description.end_time,
                });
                return {
                    ...this.currentChart,
                    eventId: this.event._id,
                    begin,
                    cease,
                };
            }

            if (this.currentTab === 'activations') {
                let metrics = this.currentChart.metrics || [];

                if (!['private', 'hybrid'].includes(this.regAccessType)) {
                    metrics = metrics.filter(d => d !== 'accepted_rsvp');
                }

                if (!['public', 'hybrid'].includes(this.regAccessType)) {
                    metrics = metrics.filter(d => d !== 'self_registered_users');
                }

                return { ...this.currentChart, eventId: this.event._id, metrics };
            }

            return { ...this.currentChart, eventId: this.event._id };
        },

        /** @returns {Vue.Component} */
        currentChartComponent() {
            return TYPE_COMPONENT_MAPPING[this.currentChart.type];
        }
    },

    created() {
        this.$utils.charts;

        this.$services.pax.getRegistrationConfig(this.event._id)
            .then(regConfig => { this.regAccessType = regConfig?.settings?.access_type; })
            .catch(() => undefined);
    },

    methods: {
        /** @type {(d: { start: number, end: number }) => { begin: number, cease: number }} */
        maxTwoYearsTimeRange({ start, end }) {
            const twoYearsBeforeEnd = this.$utils.time.dateToUnix(
                this.$utils.time.twoYearsBefore(end * 1000)
            );
            return {
                begin: Math.max(start, twoYearsBeforeEnd),
                cease: end,
            };
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.charts.length)?_c('div',{staticClass:"tabbed-charts"},[(_vm.charts.length > 1)?_c('div',{staticClass:"buttons-toggler"},_vm._l((_vm.charts),function(chart){return _c('button',{key:chart,staticClass:"btn",class:{ 'btn-primary-alt' : chart === _vm.currentTab },attrs:{"type":"button"},on:{"click":function($event){_vm.currentTab = chart}}},[_vm._v(_vm._s(_vm.$t(("analytics.charts." + chart + ".title"))))])}),0):_vm._e(),_c('div',{staticClass:"chart-area"},[_c(_vm.currentChartComponent,_vm._b({key:_vm.currentTab,tag:"component",class:_vm.currentTab,scopedSlots:_vm._u([{key:"details",fn:function(ref){return [_c('expandable-content',{staticClass:"metrics",attrs:{"show-toggler":false,"clickable-header":true,"slim":true},scopedSlots:_vm._u([{key:"header",fn:function(ref){
var open = ref.open;
return [_c('h4',{class:{ open: open }},[_vm._v(_vm._s(_vm.$t('analytics.metrics.more'))),_c('i',{staticClass:"ic-chevron-down"})])]}}],null,true)},_vm._l((_vm.currentChart.metrics),function(metric){return _c('div',{staticClass:"metric"},[_c('div',{staticClass:"name"},[_c('span',{staticClass:"color",style:({ 'background-color': _vm.currentChart.lineColor(metric) })}),_vm._v(_vm._s(_vm.$t(("analytics.metrics." + metric + ".title"))))]),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.$t(("analytics.metrics." + metric + ".description"))))])])}),0)]}}],null,false,2747666077)},'component',_vm.currentChartProps,false))],1)]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "TabbedCharts.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__